// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader__2anC8"};